import React from 'react';
import Breadcrumb from './breadcrumb';
import type { BreadcrumbLink } from './breadcrumb';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

interface Props {
  breadcrumbs?: BreadcrumbLink[];
  children?: React.ReactNode;
  description?: string;
  icon?: FontAwesomeIconProps['icon'];
  imgSrc?: string | null;
  title: string;
}

export default function PageHeaderHeading({ breadcrumbs, children, description, icon, imgSrc, title }: Props) {
  let headingContent: React.ReactNode;

  if (description) {
    headingContent =
      <div className="d-flex gap-3 align-items-center">
        <h5>{title}</h5>
        <div className="vr d-none d-md-flex" />
        <div className="d-none d-md-flex">
          <div className="text-muted">{description}</div>
        </div>
      </div>;
  } else {
    headingContent =
      <div>
        {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumb links={breadcrumbs} />}
        <h5>{title}</h5>
        {children}
      </div>;
  }

  return (
    <div className={classNames('d-flex align-items-center', imgSrc ? 'gap-4' : 'gap-2')}>
      {imgSrc && <img className="rounded" height={82} src={imgSrc} width={164} />}
      {icon && <div className="d-none d-md-block"><FontAwesomeIcon icon={icon} size="xl" /></div>}
      {headingContent}
    </div>
  );
}
